<!-- scc-confirm-data.component.html -->
<div class="dicom-data-popup">
  <div class="columns">
    <div class="column dicom-data-column">
      <div class="dicom-header">
        <h3>
          <b>{{ 'viewer.serie.scc.dicom_data' | translate }}</b>
        </h3>
        <div class="header-buttons">
          <button mat-button (click)="toggleExpandAll()" *ngIf="(input?.dicomData?.length ?? 0) > 1">
            <mat-icon>{{ expandAll ? 'unfold_less' : 'unfold_more' }}</mat-icon>
            {{ expandAll ? 'Tout replier' : 'Tout déplier' }}
          </button>
        </div>
      </div>

      <ng-container *ngIf="input?.dicomData as dicomFiles">
        <mat-accordion multi="true">
          <mat-expansion-panel
            *ngFor="let file of dicomFiles; let i = index; trackBy: trackByFileIndex"
            [expanded]="i === 0"
            (opened)="onPanelToggle(i, true)"
            (closed)="onPanelToggle(i, false)">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>insert_drive_file</mat-icon>
                Fichier {{ i + 1 }} / {{ dicomFiles.length }}
              </mat-panel-title>
              <mat-panel-description>
                {{ file.tags['PatientName'] || file.tags['0010,0010'] || 'Nom patient non disponible' }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-container *ngIf="isPanelExpanded(i); else lazyContent">
              <ul>
                <ng-container *ngFor="let entry of objectEntries(file.tags); trackBy: trackByTagKey">
                  <li>
                    <strong>{{ entry.key }}: </strong>
                    <ng-container *ngIf="isSimpleValue(entry.value); else recursiveDisplay">
                      <span *ngIf="isArray(entry.value); else singleValue">
                        <span *ngFor="let val of entry.value">{{ val }} </span>
                      </span>
                      <ng-template #singleValue>
                        {{ entry.value }}
                      </ng-template>
                    </ng-container>
                    <ng-template #recursiveDisplay>
                      <ng-container *ngTemplateOutlet="recursive; context:{ data: entry.value }"></ng-container>
                    </ng-template>
                  </li>
                </ng-container>
              </ul>
            </ng-container>

            <ng-template #lazyContent>
              <div style="padding: 8px; color: #666;">Cliquez pour afficher les détails...</div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>
    </div>

    <div class="column other-data-column">
      <h3>
        <b>{{ 'viewer.serie.scc.lof_data' | translate }}</b>
      </h3>
      <ul *ngIf="input?.lofData">
        <li>
          <strong>Nom : </strong> {{ input?.lofData?.nom }}
        </li>
        <li>
          <strong>N° du transpondeur : </strong> {{ input?.lofData?.transpondeur }}
        </li>
        <li>
          <strong>Race : </strong> {{ input?.lofData?.race }}
        </li>
        <li>
          <strong>Date de naissance : </strong>
          {{ input?.lofData?.dateNaissance ? input?.lofData?.dateNaissance : 'Non renseignée' }}
        </li>
      </ul>

      <mat-checkbox
        *ngIf="input?.lofData"
        id="confirmDog"
        [formControl]="confirmDog">
        Je certifie que les images déposées sont celles associées à ce chien uniquement : {{ input?.lofData?.nom }} - {{ input?.lofData?.transpondeur }}
      </mat-checkbox>
    </div>
  </div>
</div>

<ng-template #recursive let-data="data">
  <ul *ngIf="isObject(data)">
    <ng-container *ngFor="let entry of objectEntries(data); trackBy: trackByTagKey">
      <li>
        <strong>{{ entry.key }}: </strong>
        <ng-container *ngIf="isSimpleValue(entry.value); else recursiveDisplayObj">
          <span *ngIf="isArray(entry.value); else singleValueObj">
            <span *ngFor="let val of entry.value">{{ val }} </span>
          </span>
          <ng-template #singleValueObj>
            {{ entry.value }}
          </ng-template>
        </ng-container>
        <ng-template #recursiveDisplayObj>
          <ng-container *ngTemplateOutlet="recursive; context:{ data: entry.value }"></ng-container>
        </ng-template>
      </li>
    </ng-container>
  </ul>

  <ul *ngIf="isArray(data) && !isSimpleValue(data)">
    <li *ngFor="let item of data">
      <ng-container *ngIf="isSimpleValue(item); else recursiveDisplayArray">
        {{ item }}
      </ng-container>
      <ng-template #recursiveDisplayArray>
        <ng-container *ngTemplateOutlet="recursive; context:{ data: item }"></ng-container>
      </ng-template>
    </li>
  </ul>
</ng-template>
